import { useEffect } from 'react';

//helpers
import { useHaltPropagation } from  '@/components/hooks/utility/useHaltPropagation';

//interfaces
import { IArchiveContentProps } from  '@/interfaces/activityFeed';



const UseArchiveContent = ({showModal, onCloseClick, onConfirmClick, existsInMultiplePlaces}: IArchiveContentProps) => {
    const modalIsOpen = showModal;
    const archivalQuestion = existsInMultiplePlaces 
        ? "This content item exists in multiple places. Are you sure you want to archive this content from this location, others will remain published?" 
        : "Are you sure you want to archive this content?"
    
    const handleCancelClick = (e: React.MouseEvent) => {
        useHaltPropagation(e);
        onCloseClick();
    };

    const handleConfirmClick = (e: React.MouseEvent) => {
        useHaltPropagation(e);
        onConfirmClick();
    };

    useEffect(() => {
        if (modalIsOpen) {
            document.body.classList.add('archive-content-modal-is-open')
        } else {
            document.body.classList.remove('archive-content-modal-is-open')
        }
    }, [modalIsOpen])

    return { archivalQuestion, handleCancelClick, handleConfirmClick }
};
export default UseArchiveContent

export const ArchiveContentConstants = {
    title : "Archive Content",
    cancelButtonText : "Cancel",
    cancelButtonAriaLabel : "Cancel and do not archive the content",
    confirmButtonText : "Confirm",
    confirmButtonAriaLabel : "Confirm and archive the content" 
}